// Used to formatting date string, to API format
export const addZeroPrefixInString = (key) => {
  return key.toString().length == 1 ? "0" + key : key;
};

export const exchange = "NSE";
export const defaultTabName = "New tab";

export const monthNumber = {
  "Jan": "01",
  "Feb": "02",
  "Mar": "03",
  "Apr": "04",
  "May": "05",
  "Jun": "06",
  "Jul": "07",
  "Aug": "08",
  "Sep": "09",
  "Oct": "10",
  "Nov": "11",
  "Dec": "12",
}

export const monthName = {
  "01" : "JAN",
  "02" : "FEB",
  "03": "MAR",
  "04": "APR",
  "05": "MAY",
  "06": "JUN",
  "07": "JUL",
  "08": 'AUG',
  "09": "SEP",
  "10": "OCT",
  "11": "NOV",
  "12": "DEC",
}

export const pfValues = [
    {
      "key": "1A",
      "value": 20.94
    },
    {
      "key": "1B",
      "value": 19.58
    },
    {
      "key": "1C",
      "value": 18.22
    },
    {
      "key": "1D",
      "value": 16.86
    },
    {
      "key": "1E",
      "value": 15.5
    },
    {
      "key": "1F",
      "value": 14.6
    },
    {
      "key": "1G",
      "value": 13.7
    },
    {
      "key": "1H",
      "value": 12.8
    },
    {
      "key": "1I",
      "value": 11.9
    },
    {
      "key": 2,
      "value": 11.225
    },
    {
      "key": "2A",
      "value": 10.1
    },
    {
      "key": "2B",
      "value": 9.035
    },
    {
      "key": "2C",
      "value": 8.61
    },
    {
      "key": "2D",
      "value": 8.115
    },
    {
      "key": "2E",
      "value": 7.49
    },
    {
      "key": "2F",
      "value": 6.99
    },
    {
      "key": "2G",
      "value": 6.6
    },
    {
      "key": "2H",
      "value": 6.3
    },
    {
      "key": "2I",
      "value": 5.925
    },
    {
      "key": 3,
      "value": 5.618
    },
    {
      "key": "3A",
      "value": 5.31
    },
    {
      "key": "3B",
      "value": 5.025
    },
    {
      "key": "3C",
      "value": 4.885
    },
    {
      "key": "3D",
      "value": 4.699
    },
    {
      "key": "3E",
      "value": 4.49
    },
    {
      "key": "3F",
      "value": 4.305
    },
    {
      "key": "3G",
      "value": 4.15
    },
    {
      "key": "3H",
      "value": 4.035
    },
    {
      "key": "3I",
      "value": 3.885
    },
    {
      "key": 4,
      "value": 3.745
    },
    {
      "key": "4A",
      "value": 3.625
    },
    {
      "key": "4B",
      "value": 3.525
    },
    {
      "key": "4C",
      "value": 3.435
    },
    {
      "key": "4D",
      "value": 3.345
    },
    {
      "key": "4E",
      "value": 3.235
    },
    {
      "key": "4F",
      "value": 3.14
    },
    {
      "key": "4G",
      "value": 3.06
    },
    {
      "key": "4H",
      "value": 2.995
    },
    {
      "key": "4I",
      "value": 2.915
    },
    {
      "key": 5,
      "value": 2.87
    },
    {
      "key": "5A",
      "value": 2.705
    },
    {
      "key": "5B",
      "value": 2.496
    },
    {
      "key": "5C",
      "value": 2.33
    },
    {
      "key": "5D",
      "value": 2.2
    },
    {
      "key": "5E",
      "value": 2.1
    },
    {
      "key": "5F",
      "value": 1.975
    },
    {
      "key": "5G",
      "value": 1.872
    },
    {
      "key": "5H",
      "value": 1.77
    },
    {
      "key": "5I",
      "value": 1.675
    },
    {
      "key": 6,
      "value": 1.628
    }
]

export const protectiveFactorsForPositional = [
  {
    "key": "A",
    "value": 1
  },
  {
    "key": "B",
    "value": 2
  },
  {
    "key": "C",
    "value": 2.6
  },
  {
    "key": "D",
    "value": 3.3
  },
  {
    "key": "E",
    "value": 4.25
  },
  {
    "key": "F",
    "value": 5.2
  },
  {
    "key": "G",
    "value": 6
  },
  {
    "key": "H",
    "value": 6.6
  },
  {
    "key": "I",
    "value": 7.56
  },
  {
    "key": "ONE",
    "value": 8.49
  },
  {
    "key": "1A",
    "value": 9.469
  },
  {
    "key": "1B",
    "value": 10.52
  },
  {
    "key": "1C",
    "value": 11.1
  },
  {
    "key": "1D",
    "value": 11.8
  },
  {
    "key": "1E",
    "value": 12.7
  },
  {
    "key": "1F",
    "value": 13.7
  },
  {
    "key": "1G",
    "value": 14.5
  },
  {
    "key": "1H",
    "value": 15.1
  },
  {
    "key": "1I",
    "value": 16.05
  },
  {
    "key": "TWO",
    "value": 17
  },
  {
    "key": "2A",
    "value": 18
  },
  {
    "key": "2B",
    "value": 19
  },
  {
    "key": "2C",
    "value": 19.6
  },
  {
    "key": "2D",
    "value": 20.3
  },
  {
    "key": "2E",
    "value": 21.2
  },
  {
    "key": "2F",
    "value": 22.2
  },
  {
    "key": "2G",
    "value": 23
  },
  {
    "key": "2H",
    "value": 23.6
  },
  {
    "key": "2I",
    "value": 24.55
  },
  {
    "key": "THREE",
    "value": 25.5
  },
  {
    "key": "3A",
    "value": 26.5
  },
  {
    "key": "3B",
    "value": 27.5
  },
  {
    "key": "3C",
    "value": 28.1
  },
  {
    "key": "3D",
    "value": 28.8
  },
  {
    "key": "3E",
    "value": 30.7
  },
  {
    "key": "3F",
    "value": 31.7
  },
  {
    "key": "3G",
    "value": 32.5
  },
  {
    "key": "3H",
    "value": 33.1
  },
  {
    "key": "3I",
    "value": 34.05
  }
]

export const pfValuesForOptions = [
  {
    "key": "1A",
    "value": 19.1579
  },
  {
    "key": "1B",
    "value": 17.9136
  },
  {
    "key": "1C",
    "value": 16.6694
  },
  {
    "key": "1D",
    "value": 15.4251
  },
  {
    "key": "1E",
    "value": 14.1809
  },
  {
    "key": "1F",
    "value": 13.3575
  },
  {
    "key": "1G",
    "value": 12.534
  },
  {
    "key": "1H",
    "value": 11.7106
  },
  {
    "key": "1I",
    "value": 10.8872
  },
  {
    "key": "TWO",
    "value": 10.2697
  },
  {
    "key": "2A",
    "value": 9.24043
  },
  {
    "key": "2B",
    "value": 8.26606
  },
  {
    "key": "2C",
    "value": 7.87723
  },
  {
    "key": "2D",
    "value": 7.42436
  },
  {
    "key": "2E",
    "value": 6.85255
  },
  {
    "key": "2F",
    "value": 6.39511
  },
  {
    "key": "2G",
    "value": 6.0383
  },
  {
    "key": "2H",
    "value": 5.76383
  },
  {
    "key": "2I",
    "value": 5.42075
  },
  {
    "key": "THREE",
    "value": 5.13987
  },
  {
    "key": "3A",
    "value": 4.85809
  },
  {
    "key": "3B",
    "value": 4.59734
  },
  {
    "key": "3C",
    "value": 4.46926
  },
  {
    "key": "3D",
    "value": 4.29909
  },
  {
    "key": "3E",
    "value": 4.10787
  },
  {
    "key": "3F",
    "value": 3.93862
  },
  {
    "key": "3G",
    "value": 3.79681
  },
  {
    "key": "3H",
    "value": 3.6916
  },
  {
    "key": "3I",
    "value": 3.55436
  },
  {
    "key": "FOUR",
    "value": 3.42628
  },
  {
    "key": "4A",
    "value": 3.31649
  },
  {
    "key": "4B",
    "value": 3.225
  },
  {
    "key": "4C",
    "value": 3.14266
  },
  {
    "key": "4D",
    "value": 3.06032
  },
  {
    "key": "4E",
    "value": 2.95968
  },
  {
    "key": "4F",
    "value": 2.87277
  },
  {
    "key": "4G",
    "value": 2.79957
  },
  {
    "key": "4H",
    "value": 2.74011
  },
  {
    "key": "4I",
    "value": 2.66692
  },
  {
    "key": "FIVE",
    "value": 2.62575
  },
  {
    "key": "5A",
    "value": 2.47479
  },
  {
    "key": "5B",
    "value": 2.28357
  },
  {
    "key": "5C",
    "value": 2.1317
  },
  {
    "key": "5D",
    "value": 2.01277
  },
  {
    "key": "5E",
    "value": 1.92128
  },
  {
    "key": "5F",
    "value": 1.80692
  },
  {
    "key": "5G",
    "value": 1.71268
  },
  {
    "key": "5H",
    "value": 1.61936
  },
  {
    "key": "5I",
    "value": 1.53245
  },
  {
    "key": "SIX",
    "value": 1.48975
  },
  {
    "key": "6A",
    "value": 1.48213
  },
  {
    "key": "6B",
    "value": 1.46566
  },
  {
    "key": "6C",
    "value": 1.44736
  },
  {
    "key": "6D",
    "value": 1.42906
  },
  {
    "key": "6E",
    "value": 1.41077
  },
  {
    "key": "6F",
    "value": 1.39247
  },
  {
    "key": "6G",
    "value": 1.37234
  },
  {
    "key": "6H",
    "value": 1.33575
  },
  {
    "key": "6I",
    "value": 1.29915
  },
  {
    "key": "SEVEN",
    "value": 1.26255
  },
  {
    "key": "7A",
    "value": 1.22596
  },
  {
    "key": "7B",
    "value": 1.17936
  },
  {
    "key": "7C",
    "value": 1.13277
  },
  {
    "key": "7D",
    "value": 1.06617
  },
  {
    "key": "7E",
    "value": 0.99957
  },
  {
    "key": "7F",
    "value": 0.91298
  },
  {
    "key": "7G",
    "value": 0.82638
  },
  {
    "key": "7H",
    "value": 0.9034
  },
  {
    "key": "7I",
    "value": 0.80681
  },
  {
    "key": "EIGHT",
    "value": 0.70021
  }
];

//Protective factors for Swing trade / Advanced postional / F & O Swing master
export const pfValuesForSwingTrade = [
  {
    "key": "1A",
    "value": 19.15787
  },
  {
    "key": "1B",
    "value": 17.91362
  },
  {
    "key": "1C",
    "value": 16.66936
  },
  {
    "key": "1D",
    "value": 15.42511
  },
  {
    "key": "1E",
    "value": 14.18085
  },
  {
    "key": "1F",
    "value": 13.35745
  },
  {
    "key": "1G",
    "value": 12.53404
  },
  {
    "key": "1H",
    "value": 11.71064
  },
  {
    "key": "1I",
    "value": 10.88723
  },
  {
    "key": 2,
    "value": 10.26968
  },
  {
    "key": "2A",
    "value": 9.240426
  },
  {
    "key": "2B",
    "value": 8.266064
  },
  {
    "key": "2C",
    "value": 7.877234
  },
  {
    "key": "2D",
    "value": 7.424362
  },
  {
    "key": "2E",
    "value": 6.852553
  },
  {
    "key": "2F",
    "value": 6.395106
  },
  {
    "key": "2G",
    "value": 6.038298
  },
  {
    "key": "2H",
    "value": 5.76383
  },
  {
    "key": "2I",
    "value": 5.420745
  },
  {
    "key": 3,
    "value": 5.139872
  },
  {
    "key": "3A",
    "value": 4.858085
  },
  {
    "key": "3B",
    "value": 4.59734
  },
  {
    "key": "3C",
    "value": 4.469255
  },
  {
    "key": "3D",
    "value": 4.299085
  },
  {
    "key": "3E",
    "value": 4.107872
  },
  {
    "key": "3F",
    "value": 3.938617
  },
  {
    "key": "3G",
    "value": 3.796809
  },
  {
    "key": "3H",
    "value": 3.691596
  },
  {
    "key": "3I",
    "value": 3.554362
  },
  {
    "key": 4,
    "value": 3.426277
  },
  {
    "key": "4A",
    "value": 3.316489
  },
  {
    "key": "4B",
    "value": 3.225
  },
  {
    "key": "4C",
    "value": 3.14266
  },
  {
    "key": "4D",
    "value": 3.060319
  },
  {
    "key": "4E",
    "value": 2.959681
  },
  {
    "key": "4F",
    "value": 2.872766
  },
  {
    "key": "4G",
    "value": 2.799574
  },
  {
    "key": "4H",
    "value": 2.740106
  },
  {
    "key": "4I",
    "value": 2.666915
  },
  {
    "key": 5,
    "value": 2.625745
  },
  {
    "key": "5A",
    "value": 2.474787
  },
  {
    "key": "5B",
    "value": 2.283574
  },
  {
    "key": "5C",
    "value": 2.131702
  },
  {
    "key": "5D",
    "value": 2.012766
  },
  {
    "key": "5E",
    "value": 1.921277
  },
  {
    "key": "5F",
    "value": 1.806915
  },
  {
    "key": "5G",
    "value": 1.712681
  },
  {
    "key": "5H",
    "value": 1.619362
  },
  {
    "key": "5I",
    "value": 1.532447
  },
  {
    "key": 6,
    "value": 1.489749
  },
  {
    "key": "6A",
    "value": 1.482128
  },
  {
    "key": "6B",
    "value": 1.46566
  },
  {
    "key": "6C",
    "value": 1.447362
  },
  {
    "key": "6D",
    "value": 1.429064
  },
  {
    "key": "6E",
    "value": 1.410766
  },
  {
    "key": "6F",
    "value": 1.392468
  },
  {
    "key": "6G",
    "value": 1.37234
  },
  {
    "key": "6H",
    "value": 1.335745
  },
  {
    "key": "6I",
    "value": 1.299149
  },
  {
    "key": "7",
    "value": 1.262553
  }
]

export const structForBasicAndLongTermData = {
  labelName: "New tab",
  exchange: "NSE",
  inst: "",
  expiry: "",
  symbol: "",
  endDate: "",
  swing: 0,
  latestSwing: 0,
  swingVal: 0.0,

  dateTwo:"",
  stopCalc: false,
  endCandleDate: "",

  data: [],
  initPhase: [],
  currentPhase: [],
  orderPlaceMentBuy: [],
  orderPlaceMentSell: [],
  additionalDetails: [],
  candleData: {},
  correctionCandleData: {},
  initialLastCloseValue: 0,
  
  hideSelectForm: false,
  hideDataDiv: true,
  hideInitPhaseDiv: true,
  orderPlacementDiv: true,
  currentPhaseDiv: true,
  additionalDetailsDiv: true,
  hideStoplossAndTargets: true,
  notify: false,
  closeVerify: false,

  upPhasedValues: [],
  downPhasedValues: [],
  whichPhase: ''
}

export const structForLongTermData = {
  labelName: "New tab",
  exchange: "NSE",
  symbol: "",
  endDate: "",
  inst: "",
  expiry: "",
  swing: 0,
  swingVal: 0.0,

  dateTwo:"",

  data: [],
  initPhase: [],
  currentPhase: [],
  orderPlaceMentBuy: [],
  orderPlaceMentSell: [],
  additionalDetails: [],
  candleData: {},
  initialLastCloseValue: 0,
  
  hideSelectForm: false,
  hideDataDiv: true,
  hideInitPhaseDiv: true,
  orderPlacementDiv: true,
  currentPhaseDiv: true,
  additionalDetailsDiv: true,
  hideStoplossAndTargets: true,

  upPhasedValues: [],
  downPhasedValues: [],
  whichPhase: ''
}

export const isValidDate = (dateString) => new Date(dateString).toString() !== 'Invalid Date'

function getAPIToken(token) {
  fetch('https://auth.truedata.in/token', {
    method: 'POST',            
    body: new URLSearchParams({
        username: "tdwsp149",
        password: "vinayak@149",
        grant_type: 'password'
    })
  })
  .then(res => res.json())
  .then((data) => {
    token(data['access_token'])
  })
  .catch((err) => {
    token("err")
    console.log('Error', 'Error from token generation', err);
  })   
}

export function checkSymbolExist(symbol, callback) {
  getAPIToken(function(token) {
    if(token !== 'err') {
      let fromDate = new Date();
      let fromDateYear = fromDate.getFullYear().toString()[2] + fromDate.getFullYear().toString()[3];
      let fromDateMonth = (fromDate.getMonth() + 1).toString();
      let fromDateDay = fromDate.getDate().toString();

      let symbolKey = symbol.sym

      if(symbol.ty === "fut") {
        symbolKey = symbol.sym + addZeroPrefixInString(fromDateYear) + monthName[addZeroPrefixInString(fromDateMonth)] + 'FUT'
      }

      fromDate = addZeroPrefixInString(fromDateYear) + addZeroPrefixInString(fromDateMonth) + addZeroPrefixInString(fromDateDay) + "T09:15:00";
      let toDate = addZeroPrefixInString(fromDateYear) + addZeroPrefixInString(fromDateMonth) + addZeroPrefixInString(fromDateDay) + "T09:45:00";
      
      let url = "https://history.truedata.in/getbars?symbol="+encodeURIComponent(symbolKey)+"&from="+fromDate+"&to="+toDate+"&response=json&interval=15min"+"&segment="+symbol.ty

      fetch(url, {
          method: "GET",
          headers: { "Authorization": "Bearer "+ token }
      })
      .then(res => res.json())
      .then((data) => {
        if(data['status'] == 'Success' || ((data['Records'] === "") && ( data['status'] !== "Symbol does not exist" ))) {
          callback(true)
        } else {
          alert(JSON.stringify(data['status']))
        }
      })
      .catch((err) => {
        console.log('Error', 'Error from check symbol exist', err);
      })
    }
  })
}

export function fetchDataFromAPI(symbol, fromDate, toDate, interval, callBack)  {
  var stockData = []
  fetch('https://auth.truedata.in/token', {
    method: 'POST',            
    body: new URLSearchParams({
        username: "tdwsp149",
        password: "vinayak@149",
        grant_type: 'password'
    })
  })
  .then(res => res.json())
  .then((data) => {
      // To fetch data
      if(data['error'] === 'invalid_grant') {
        callBack({
          error: true,
          status: data['error_description']
        })
        return
      }
      fetch("https://history.truedata.in/getbars?symbol="+symbol+"&from="+fromDate+"&to="+toDate+"&response=json&interval="+interval, {
          method: "GET",
          headers: {
              "Authorization": "Bearer "+data['access_token'],
          }
      })
      .then(res => res.json())
      .then((data1) => {
        if(data1['status'] != 'Success') {
          callBack({
            error: true,
            status: data1['status']
          })
          // return;
        }

        let lastTenElements = data1['Records']
        lastTenElements.map((item, index) => {
            if(item[0].split("T")[1] === '15:30:00') {
                lastTenElements.splice(index, 1)
            }
        })

        let duplicateValueIndex = []
        for(let i = 1; i < lastTenElements.length; i++) {
          if(lastTenElements[i - 1][0] == lastTenElements[i][0]) {
            duplicateValueIndex.push(i)
          }
        }

        for(let i = 0; i < duplicateValueIndex.length; i++) {
          lastTenElements.splice(duplicateValueIndex[i], 1)
        }

        let sortedArray = []
        if(lastTenElements.length > 10) {
          sortedArray = lastTenElements.slice(Math.abs(lastTenElements.length - 10)) // Here will get only ten days stock data
          // Re formatting data to our preference
          sortedArray.map((item, index) => {
            stockData.push({
                'date': item[0],
                'open': item[1],
                'high': item[2],
                'low': item[3],
                'close': item[4]
            })
          })
        } else {
          sortedArray = lastTenElements
          let sortedArrayLength = lastTenElements.length - 1

          for(let i = 0; i < (9 - sortedArrayLength); i++) {
            stockData.push({
              'date': sortedArray[0][0],
              'open': 0,
              'high': 0,
              'low': 0,
              'close': sortedArray[0][4]
            })
          }

          sortedArray.map((item, index) => {
            stockData.push({
              'date': item[0],
              'open': item[1],
              'high': item[2],
              'low': item[3],
              'close': item[4]
            })
          })
        }
        callBack(stockData)        
      })
      .catch((err) => {
        console.log('Error', 'Error from fetchDataFromAPI function', err);
      })
    })
    .catch((err) => {
      console.log('Error', 'Error from fetchDataFromAPI function', err);
    })
}

export const higestValue = (val1, val2, val3) => {
  if((val1 < val2) && (val2 > val3)) {
      return val2
  } else if(val1 > val3) {
      return val1
  } else {
      return val3
  }
}

export const lowestValue = (val1, val2, val3) => {
  if((val1 > val2) && (val2 < val3)) {
      return val2
  } else if(val1 > val3) {
      return val3
  } else {
      return val1
  }
}

function removeCandle (data) {
  if (data === "09:00:00") {
    return true 
  }
  if (data === "16:00:00") {
    return true 
  }
  if (data === "15:30:00") {
    return true 
  }

  return false
}


export function fetchDataFromAPIReturnHeikinAshiValue(symbol, fromDate, toDate, refDate, interval, calcAgain, callBack)  {
  var stockData = []
  fetch('https://auth.truedata.in/token', {
    method: 'POST',
    body: new URLSearchParams({
        username: "tdwsp149",
        password: "vinayak@149",
        grant_type: 'password'
    })
  })
  .then(res => res.json())
  .then((data) => {
      fetch("https://history.truedata.in/getbars?symbol="+symbol+"&from="+fromDate+"&to="+toDate+"&response=json&interval="+interval, {
          method: "GET",
          headers: {
              "Authorization": "Bearer "+data['access_token'],
          }
      })
      .then(res => res.json())
      .then((data1) => {
        if(data1['status'] != 'Success') {
          callBack({
            error: true,
            status: data1['status']
          })
        }

        let lastTenElements = data1['Records']

        lastTenElements.map((item, index) => {
          if(item[0].split("T")[1] === '16:00:00') {
            lastTenElements.splice(index, 1)
          }
        })

        lastTenElements.map((item, index) => {
          if(item[0].split("T")[1] === '15:30:00') {
            lastTenElements.splice(index, 1)
          }
        })

        lastTenElements.map((item, index) => {
          if(item[0].split("T")[1] === '09:00:00') {
            lastTenElements.splice(index, 1)
          }
        })

        let heikinAshiOpen = 0
        let heikinAshiHigh = 0
        let heikinAshiLow = 0
        let heikinAshiClose = 0

        let normalCandleData = []

        lastTenElements.map((item, index) => {
          if(item[0] >= refDate) {
            normalCandleData.push({
              'date': item[0],
              'open': item[1],
              'high': item[2],
              'low': item[3],
              'close': item[4]
            })
          }

          if(index === 0) {
              heikinAshiOpen = Number(item[1])
              heikinAshiClose = ( Number(item[1]) + Number(item[2]) + Number(item[3]) + Number(item[4]) ) / 4
              
              heikinAshiHigh = higestValue(heikinAshiOpen, Number(item[2]), heikinAshiClose)
              heikinAshiLow = lowestValue(heikinAshiOpen, Number(item[3]), heikinAshiClose)

              item[4] = heikinAshiClose
          } else {
              heikinAshiOpen = ( Number(lastTenElements[index - 1][1]) + Number(lastTenElements[index - 1][4]) ) / 2
              heikinAshiClose = ( Number(item[1]) + Number(item[2]) + Number(item[3]) + Number(item[4]) ) / 4
              item[1] = heikinAshiOpen
              item[4] = heikinAshiClose

              heikinAshiHigh = higestValue(heikinAshiOpen, Number(item[2]), heikinAshiClose)
              heikinAshiLow = lowestValue(heikinAshiOpen, Number(item[3]), heikinAshiClose)
          }

          if(item[0] >= refDate) {
            stockData.push({
                'date': item[0],
                'open': heikinAshiOpen,
                'high': heikinAshiHigh,
                'low': heikinAshiLow,
                'close': heikinAshiClose
            })
          }
        })

        callBack(stockData, normalCandleData)
      })
      .catch((err) => {
        console.error('Chk Error', 'Error from fetchDataFromAPIReturnHeikinAshiValue', err);
      })
    })
    .catch((err) => {
      console.log('Chk Error', 'Error from fetchDataFromAPI function', err);
    })
}

export function fetchDataFromAPIAdvIntraday(symbol, fromDate, toDate, interval, callBack)  {
  fetch('https://auth.truedata.in/token', {
    method: 'POST',
    body: new URLSearchParams({
        username: "tdwsp149",
        password: "vinayak@149",
        grant_type: 'password'
    })
  })
  .then(res => res.json())
  .then((data) => {
    fetch("https://history.truedata.in/getbars?symbol="+symbol+"&from="+fromDate+"&to="+toDate+"&response=json&interval="+interval, {
        method: "GET",
        headers: {
            "Authorization": "Bearer "+data['access_token'],
        }
    })
    .then(res => res.json())
    .then((data1) => {
      if(data1['status'] != 'Success') {
        callBack({
          error: true,
          status: data1['status']
        })
      }

      let lastTenElements = data1['Records']

      lastTenElements.map((item, index) => {
          if(item[0].split("T")[1] === '15:30:00') {
            lastTenElements.splice(index, 1)
          }

          if(item[0].split("T")[1] === '09:00:00') {
            lastTenElements.splice(index, 1)
          }

          if(item[0].split("T")[1] === '16:00:00') {
            lastTenElements.splice(index, 1)
          }
      })

      let normalCandleData = []

      lastTenElements.map((item, index) => {
        normalCandleData.push({
          'date': item[0],
          'open': item[1],
          'high': item[2],
          'low': item[3],
          'close': item[4]
        })
      })
      callBack(normalCandleData)
    })
    .catch((err) => {
      console.log('Chk Error', 'Error from fetchDataFromAPI function', err);
    })
  })
  .catch((err) => {
    console.log('Chk Error', 'Error from fetchDataFromAPI function', err);
  })
}

export function fetchDataFromAPIReturnHeikinAshiValueForAgain(symbol, fromDate, toDate, refDate, interval, callBack)  {
  var stockData = []
  fetch('https://auth.truedata.in/token', {
    method: 'POST',            
    body: new URLSearchParams({
        username: "tdwsp149",
        password: "vinayak@149",
        grant_type: 'password'
    })
  })
  .then(res => res.json())
  .then((data) => {
      // To fetch data
      fetch("https://history.truedata.in/getbars?symbol="+symbol+"&from="+fromDate+"&to="+toDate+"&response=json&interval="+interval, {
          method: "GET",
          headers: {
              "Authorization": "Bearer "+data['access_token'],
          }
      })
      .then(res => res.json())
      .then((data1) => {
        if(data1['status'] != 'Success') {
          callBack({
            error: true,
            status: data1['status']
          })
        }

        let lastTenElements = data1['Records']
        lastTenElements.map((item, index) => {
            if(item[0].split("T")[1] === '15:30:00') {
                lastTenElements.splice(index, 1)
            }
        })
        
        let heikinAshiOpen = 0
        let heikinAshiHigh = 0
        let heikinAshiLow = 0
        let heikinAshiClose = 0

        let refDateLastCandleIndex = 0;

        let normalData = []
        
        lastTenElements.map((item, index) => {
          if(true) {
            if(index === 0) {
                heikinAshiOpen = Number(item[1])
                heikinAshiClose = ( Number(item[1]) + Number(item[2]) + Number(item[3]) + Number(item[4]) ) / 4
                
                heikinAshiHigh = higestValue(heikinAshiOpen, Number(item[2]), heikinAshiClose)
                heikinAshiLow = lowestValue(heikinAshiOpen, Number(item[3]), heikinAshiClose)

                item[4] = heikinAshiClose
            } else {
                heikinAshiOpen = ( Number(lastTenElements[index - 1][1]) + Number(lastTenElements[index - 1][4]) ) / 2
                heikinAshiClose = ( Number(item[1]) + Number(item[2]) + Number(item[3]) + Number(item[4]) ) / 4
                item[1] = heikinAshiOpen
                item[4] = heikinAshiClose

                heikinAshiHigh = higestValue(heikinAshiOpen, Number(item[2]), heikinAshiClose)
                heikinAshiLow = lowestValue(heikinAshiOpen, Number(item[3]), heikinAshiClose)
            }

            stockData.push({
              'date': item[0],
              'open': heikinAshiOpen,
              'high': heikinAshiHigh,
              'low': heikinAshiLow,
              'close': heikinAshiClose
            })

            normalData.push({
              date: item[0],
              'open': item[1],
              'high': item[2],
              'low': item[3],
              'close': item[4]
            })

            if(item[0] === refDate.split("T")[0]+"T15:15:00") {
              refDateLastCandleIndex = stockData.length - 1
            }
          }
        })

        let candleData = []
        let normalCandleData = []

        normalData.map((item)=> {
          if(item['date'] >= refDate) {
            normalCandleData.push(item)
          }
        })

        stockData.map((item)=> {
          if(item['date'] >= refDate) {
            candleData.push(item)
          }
        })

        callBack(candleData, refDateLastCandleIndex, normalCandleData)
      })
      .catch((err) => {
        console.log('Chk Error', 'Error from fetchDataFromAPI function', err);
      })
    })
    .catch((err) => {
      console.log('Chk Error', 'Error from fetchDataFromAPI function', err);
    })
}